/** Created by azhou on 2019/3/22.*/
<template>
  <div>
        <el-form :model="ruleForm" :rules="region" ref="ruleForm" label-width="90px" class="demo-ruleForm" label-position="top">
            <div class="commission mb-3">
                <div>订单号</div>
                <span>{{oid}}</span>
            </div>
            <div class="commission mb-3">
                <div>手续费模式</div>
                <el-radio-group v-model="ruleForm.charge_mode" size="mini" @input="resetForm('ruleForm')">
                <el-radio-button label="0">默认</el-radio-button>
                <el-radio-button label="1">百分比</el-radio-button>
                <el-radio-button label="2">数值</el-radio-button>
            </el-radio-group>
            </div>
              <el-form-item label="" prop="charge_value" v-if="ruleForm.charge_mode==1">
                <el-input v-model="ruleForm.charge_value" placeholder="请输入0至1之间的小数值" @input="handleInput($event,1)"></el-input>
              </el-form-item>
              <el-form-item label="" prop="numerical_value" v-if="ruleForm.charge_mode==2">
                <el-input v-model.verifyDigitTwo="ruleForm.numerical_value" :placeholder="'0至'+(price_pay-1)+'之间的数值'" @input="handleInput($event,2)"></el-input>
              </el-form-item>
            <!-- <left-text-number class="mb-1" v-model="ruleForm.charge_value"  :mode="1" leftText="0至1之间的小数值" :width="200" :precision="3" :min="0.001" :max="0.999" :step="0.001" v-if="ruleForm.charge_mode==1"></left-text-number> -->
            <!-- <left-text-number class="mb-1"  v-model="ruleForm.charge_value" :mode="1"  :leftText="'0至'+price_pay+'之间的数值'"  :width="200" :precision="2" :min="0.01" :max="price_pay" :step="0.01" v-if="ruleForm.charge_mode==2"></left-text-number> -->
            <el-form-item label="备注" class="lie">
                <el-input type="textarea" v-model="ruleForm.remark"  maxlength="50" show-word-limit  class="resize-none"></el-input>
            </el-form-item>
        </el-form>
        <div class="prompt">*将当前订单提交给财务进行打款</div>
        <el-button @click="$emit('finance');">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations} from 'vuex'
  export default {
    name: 'PaymentList',
    props: {
      price_pay:'',
      oid:'',
      modify:'',
    },
    computed: {
      ...mapState(['AdminDataLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      titleArr() {
        let arr = ['订单ID','所属酒店','银行卡所属','开户银行','支行名称','银行卡号','已支付金额(元)','手续费(元)','操作'];
        for(let i in arr){
          arr[i]=arr[i].replace(/\n/g, '<br/>')
        }
        return arr;
      },
      timeChoose() {
        let arr =  [
          {name:`按时间段`,value:'timeFrame'},
          {name:`按日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    data() {
      return {
        radio1:'0',
        formLabelWidth:'120px',
        ruleForm: {
          oid:'',
          charge_mode:0,                     //手续费模式：0默认1百分比2数值
          charge_value:'',                    //手续费金额
          numerical_value:'',
          remark:'',
        },
        region: {
            charge_value:[
                { validator: this.$verify.checkAge, trigger: 'blur' },
            ],
            numerical_value:[
                { validator: this.$verify.valueMax, trigger: 'blur' },
            ],
        },
        truename:'',
        timeType:'timeFrame',
        timestamp: [],
        hotel_title:'',
        showDetail:false,
        currentItem:{},     
        out_trade_no:'',
        is_merge:false,
        state:'',
      }
    },
    mounted() {
      //更新表单最大值
      this.ELFORMVALUE({min:0,max:this.price_pay-1});
      if(this.modify>0){
        this.ruleForm.numerical_value=this.modify;
        this.ruleForm.charge_mode=2;
        this.ruleForm.remark=this.remark;
      }
    },
    methods:{
    ...mapMutations(['ELFORMVALUE']),
    ...mapActions(['getAdminDataLists','adminSetInvoice','adminPayment']),
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let ruleForm=this.ruleForm;
            if(ruleForm.charge_mode==2){
              ruleForm.charge_value=ruleForm.numerical_value;
            }
            ruleForm.oid=this.oid;
            this.$emit('submitFinance',ruleForm);
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.ruleForm.charge_value='';
        this.$refs[formName].resetFields();
      },
         // 实时输入处理（优化用户体验）
    handleInput(e,index) {
       switch (index) {
              case 1: return this.ruleForm.charge_value=this.$GFUN.verifyDigitThree(e,4);
              case 2: return this.ruleForm.numerical_value=this.$GFUN.verifyDigitThree(e,3);
      }
      
    }
  }
  }
</script>
<style lang="css" scoped>
  .commission{
    display: flex;
    justify-content: space-between;
  }
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
  }
  .list-item-col{
    white-space: pre-line;
  }
  .name{
      text-align: left;
  }
  .prompt{
    color: red;
    margin-bottom: 20px;
  }
  </style>
  <style>
  .paymentist .el-form--label-top .el-form-item__label{
      display: block;
  }
  .demo-ruleForm .el-select,.demo-ruleForm  .el-autocomplete{
    width: 100%;
  }
</style>